/*! Copyright (c) Safe As Milk. All rights reserved. */
import ModalDialog from "modal-dialog";

class SearchModal extends ModalDialog {
    #boundCloseSearchModal;
    #boundOpenSearchModal;
    #boundPrepareSearchClose;
    #boundSetSearchOffset;
    #isSearchOpen = false;
    #mobileBodyScrollState = null;
    #restoreScrollFrame = 0;
    #searchTop = null;
    constructor() {
        super();
        this.#boundCloseSearchModal = this.#onCloseSearchModal.bind(this);
        this.#boundOpenSearchModal = this.#onOpenSearchModal.bind(this);
        this.#boundPrepareSearchClose = this.#onPrepareSearchClose.bind(this);
        this.#boundSetSearchOffset = this.#setSearchOffset.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        this.predictiveSearch = this.querySelector("predictive-search");
        this.#setSearchOffset();
        this.on("on:modal:opening", this.#boundOpenSearchModal);
        this.on("on:modal:closing", this.#boundPrepareSearchClose);
        this.on("on:modal:closed", this.#boundCloseSearchModal);
        window.addEventListener("resize", this.#boundSetSearchOffset);
        window.visualViewport?.addEventListener("resize", this.#boundSetSearchOffset);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.off("on:modal:opening", this.#boundOpenSearchModal);
        this.off("on:modal:closing", this.#boundPrepareSearchClose);
        this.off("on:modal:closed", this.#boundCloseSearchModal);
        window.removeEventListener("resize", this.#boundSetSearchOffset);
        window.visualViewport?.removeEventListener("resize", this.#boundSetSearchOffset);
        this.#unlockMobileBodyScroll();
    }
    #setSearchOffset() {
        if (this.#isSearchOpen && this.#searchTop !== null) {
            this.style.setProperty("--oildeco-search-offset", `${this.#searchTop}px`);
            return;
        }
        const headerContainer = document.querySelector("header-container");
        if (!headerContainer) return;
        this.#searchTop = Math.max(0, Math.round(headerContainer.getBoundingClientRect().bottom));
        this.style.setProperty("--oildeco-search-offset", `${this.#searchTop}px`);
    }
    #lockMobileBodyScroll() {
        if (this.#mobileBodyScrollState || !window.matchMedia("(max-width: 47.9275em)").matches) return;
        if (this.#restoreScrollFrame) {
            cancelAnimationFrame(this.#restoreScrollFrame);
            this.#restoreScrollFrame = 0;
        }
        const body = document.body;
        this.#mobileBodyScrollState = {
            scrollLeft: window.scrollX,
            scrollTop: window.scrollY,
            position: body.style.position,
            top: body.style.top,
            left: body.style.left,
            width: body.style.width,
            overflow: body.style.overflow
        };
        body.style.position = "fixed";
        body.style.top = `-${this.#mobileBodyScrollState.scrollTop}px`;
        body.style.left = "0";
        body.style.width = "100%";
        body.style.overflow = "hidden";
    }
    #unlockMobileBodyScroll() {
        if (!this.#mobileBodyScrollState) return;
        const body = document.body;
        const documentElement = document.documentElement;
        const state = this.#mobileBodyScrollState;
        const scrollBehavior = documentElement.style.scrollBehavior;
        this.#mobileBodyScrollState = null;
        body.style.position = state.position;
        body.style.top = state.top;
        body.style.left = state.left;
        body.style.width = state.width;
        body.style.overflow = state.overflow;
        documentElement.style.scrollBehavior = "auto";
        window.scrollTo(state.scrollLeft, state.scrollTop);
        this.#restoreScrollFrame = requestAnimationFrame((() => {
            window.scrollTo(state.scrollLeft, state.scrollTop);
            documentElement.style.scrollBehavior = scrollBehavior;
            this.#restoreScrollFrame = 0;
            this.#setSearchOffset();
        }));
    }
    #onOpenSearchModal() {
        this.#setSearchOffset();
        this.#isSearchOpen = true;
        this.setAttribute("data-oildeco-search-open", "true");
        this.#lockMobileBodyScroll();
    }
    #onPrepareSearchClose() {
        this.querySelector(".js-search-input")?.blur();
    }
    #onCloseSearchModal() {
        if (this.predictiveSearch) {
            this.predictiveSearch.close();
            const input = this.predictiveSearch.querySelector(".js-search-input");
            if (input) input.value = "";
        }
        this.removeAttribute("data-oildeco-search-open");
        this.#isSearchOpen = false;
        this.#searchTop = null;
        this.#unlockMobileBodyScroll();
    }
}

customElements.define("search-modal", SearchModal);
//# sourceMappingURL=search-modal.js.map
